/*
  Require variant selection (Theme settings > Product form).

  Liquid (snippets/product-form.liquid, snippets/shop-bar.liquid) renders the
  required options with nothing pre-selected, the hidden `id` select on an empty
  placeholder, Add to Cart disabled with a prompt, and the dynamic checkout
  button hidden. The theme's own ProductForm (theme.js) resolves the variant and
  re-enables Add to Cart once every option has a value; this script only tidies
  up around that: it reveals the dynamic checkout button when the selection is
  complete, and keeps the prompt text / price visible while it is not (the theme
  would otherwise say "Unavailable" and hide the price on multi-option products).
*/
(function () {
  var FORM = 'form[data-require-selection="true"]';
  var AWAITING = 'product__form-buttons--awaiting-selection';

  function isComplete(form) {
    var groups = {};

    form.querySelectorAll('[name^="options["]').forEach(function (input) {
      if (!(input.name in groups)) {
        groups[input.name] = false;
      }

      if (input.tagName === 'SELECT' ? input.value !== '' : input.checked) {
        groups[input.name] = true;
      }
    });

    return Object.keys(groups).every(function (name) {
      return groups[name];
    });
  }

  function update(form) {
    var prompt = form.getAttribute('data-require-selection-text');
    var container = form.closest('[data-section-id], [data-quickview-wrap]') || document;

    if (isComplete(form)) {
      form.querySelectorAll('.' + AWAITING).forEach(function (element) {
        element.classList.remove(AWAITING);
      });
      return;
    }

    form.querySelectorAll('[data-add-to-cart]').forEach(function (button) {
      var text = button.querySelector('[data-add-to-cart-text]');
      button.disabled = true;
      if (text && prompt) {
        text.textContent = prompt;
      }
    });

    form.querySelectorAll('select[name="id"]').forEach(function (select) {
      select.value = '';
    });

    container.querySelectorAll('[data-price-wrapper]').forEach(function (element) {
      element.classList.remove('product__price--hidden');
    });
  }

  // Capture phase so the theme's non-bubbling synthetic change events (sticky bar
  // -> main form sync) are seen too; deferred so it runs after the theme's own
  // change handlers have updated the form.
  document.addEventListener(
    'change',
    function (event) {
      var form = event.target.closest && event.target.closest(FORM);
      if (!form) {
        return;
      }

      var container = form.closest('[data-section-id], [data-quickview-wrap]') || document;

      setTimeout(function () {
        container.querySelectorAll(FORM).forEach(update);
      }, 0);
    },
    true
  );
})();
